// libraries.
import { useFormContext } from "react-hook-form";

// components
import {
  TitleSummary,
  WrapperSummary,
} from "@shared/DashboardComponentsSummary";
import { PublicationPriceInputsMX } from "./components/PublicationPriceInputsMX/PublicationPriceInputsMX";

// shared
import {
  CommentInput,
  CommissionPercentageInput,
  SaveInventoryPricingButton,
} from "../../shared";
import { InputSelectLeader } from "../../shared/InputSelectLeader/InputSelectLeader";
import { BonusCard } from "../../shared/BonusCard/BonusCard";

export const PriceInventorySummaryMX = () => {
  const { watch } = useFormContext();
  const minPublicationPrice = watch("minPublicationPrice");
  const publicationPrice = watch("publicationPrice");

  return (
    <div className="d-flex flex-column h-100 justify-content-between">
      <WrapperSummary>
        <TitleSummary
          title="Precio y comisión"
          subtitle="Puedes editar los valores y guardar los cambios"
        />
        <InputSelectLeader />
        <PublicationPriceInputsMX />
        <CommissionPercentageInput />
        <BonusCard
          minPublicationPrice={minPublicationPrice}
          publicationPrice={publicationPrice}
        />
      </WrapperSummary>
      <div className="d-flex flex-column gap-3 pb-2">
        <div className="line" />
        <CommentInput />
        <SaveInventoryPricingButton />
      </div>
    </div>
  );
};
